
import {
  GET_PROBLEM_LIST,
  UPDATE_PROBLEM_LOADING_STATUS,
} from "../actions/problem";
// import { pageSize } from "../../../common/utils/index";

const defVal = {
  problemList: [],
  loading: true,
  current: 0,
  pageSize: 10,
  total: 0,
  unreplyTotal: 0,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_PROBLEM_LIST:
      return Object.assign({}, state, {
        problemList: action.problemList,
        total: action.total,
        unreplyTotal: action.unreplyTotal,
        current: action.current,
        pageSize: action.pageSize,
      });

    case UPDATE_PROBLEM_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
    default:
      return state;
  }
};
